<template>
  <v-tooltip
    v-if="euid !== null"
    top
    color="black"
  >
    <template v-slot:activator="{ on, attrs }">
      <span
        v-bind="attrs"
        v-on="on"
      >{{ name }}</span>
    </template>
    <span>{{ euid }}</span>
  </v-tooltip>
  <span v-else>
    {{ name }}
  </span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    euid: {
      type: String,
      default: null
    }
  }
}
</script>
